<template>
  <div class="auth-debug">
    <h2>🔍 Vue Frontend Auth Debug</h2>
    
    <div class="section">
      <h3>1. Auth Store State</h3>
      <button @click="checkAuthStore">Check Auth Store</button>
      <div v-if="authStoreState" class="result">
        <pre>{{ JSON.stringify(authStoreState, null, 2) }}</pre>
      </div>
    </div>
    
    <div class="section">
      <h3>2. LocalStorage</h3>
      <button @click="checkLocalStorage">Check LocalStorage</button>
      <div v-if="localStorageData" class="result">
        <pre>{{ JSON.stringify(localStorageData, null, 2) }}</pre>
      </div>
    </div>
    
    <div class="section">
      <h3>3. Test API Call</h3>
      <button @click="testApiCall">Test Pages Info API</button>
      <div v-if="apiResult" class="result">
        <pre>{{ JSON.stringify(apiResult, null, 2) }}</pre>
      </div>
    </div>
    
    <div class="section">
      <h3>4. Manual Login</h3>
      <input v-model="email" placeholder="Email" value="xsada@outlook.com" />
      <input v-model="password" type="password" placeholder="Password" value="Murat@Oqu" />
      <button @click="manualLogin">Login</button>
      <div v-if="loginResult" class="result">
        <pre>{{ JSON.stringify(loginResult, null, 2) }}</pre>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useAuthStore } from '@/stores/auth';
import api from '@/services/api';

export default {
  name: 'AuthDebug',
  setup() {
    const authStore = useAuthStore();
    const authStoreState = ref(null);
    const localStorageData = ref(null);
    const apiResult = ref(null);
    const loginResult = ref(null);
    const email = ref('xsada@outlook.com');
    const password = ref('Murat@Oqu');

    const checkAuthStore = () => {
      authStoreState.value = {
        isAuthenticated: authStore.isAuthenticated,
        accessToken: authStore.accessToken ? authStore.accessToken.substring(0, 20) + '...' : null,
        refreshToken: authStore.refreshToken ? authStore.refreshToken.substring(0, 20) + '...' : null,
        user: authStore.user,
        loading: authStore.loading,
        error: authStore.error
      };
    };

    const checkLocalStorage = () => {
      const items = {};
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        const value = localStorage.getItem(key);
        // Don't show full tokens in the UI
        if (key.includes('token')) {
          items[key] = value ? value.substring(0, 20) + '...' : null;
        } else {
          items[key] = value;
        }
      }
      localStorageData.value = items;
    };

    const testApiCall = async () => {
      try {
        const response = await api.getBookPagesInfo(22);
        apiResult.value = {
          success: true,
          data: response.data
        };
      } catch (error) {
        apiResult.value = {
          success: false,
          error: error.message,
          status: error.response?.status,
          data: error.response?.data
        };
      }
    };

    const manualLogin = async () => {
      try {
        const success = await authStore.login(email.value, password.value);
        loginResult.value = {
          success,
          error: authStore.error,
          isAuthenticated: authStore.isAuthenticated
        };
      } catch (error) {
        loginResult.value = {
          success: false,
          error: error.message
        };
      }
    };

    return {
      authStoreState,
      localStorageData,
      apiResult,
      loginResult,
      email,
      password,
      checkAuthStore,
      checkLocalStorage,
      testApiCall,
      manualLogin
    };
  }
};
</script>

<style scoped>
.auth-debug {
  padding: 20px;
  font-family: Arial, sans-serif;
}

.section {
  margin: 20px 0;
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 5px;
}

.section h3 {
  margin-top: 0;
}

button {
  padding: 10px 15px;
  margin: 5px;
  cursor: pointer;
}

input {
  padding: 8px;
  margin: 5px;
  width: 250px;
}

.result {
  margin-top: 10px;
  background: #f5f5f5;
  padding: 10px;
  border-radius: 3px;
  overflow-x: auto;
}

pre {
  margin: 0;
  white-space: pre-wrap;
}
</style> 